import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { CareRecipientId } from "../../../../domain/care_recipient/CareRecipientId";
import { CareRecipientName } from "../../../../domain/care_recipient/CareRecipientName";
import { CareRecipientHouseId } from "../../../../domain/care_recipient/CareRecipientHouseId";
import { DateTime } from "../../../../domain/fundamental/DateTime";
import { CareRecipientWithSensor } from "../../../../domain/care_recipient/CareRecipientWithSensor";
import { DateObject } from "../../../../domain/fundamental/DateObject";
import { ServiceProviderId } from "../../../../domain/service_provider/ServiceProviderId";
import { getSensorFromValue } from "../../../../domain/care_recipient/Sensor";
import { getCareRecipientClassificationFromValue } from "../../../../domain/care_recipient/CareRecipientClassification";
import { BranchCode } from "../../../../domain/care_recipient/BranchCode";
import { CustomerCode } from "../../../../domain/care_recipient/CustomerCode";

export const useCareRecipientInformation = (): CareRecipientWithSensor | null => {
    const responseJson = useSelector((state: State) => state.adminCareRecipient.careRecipientInfo);

    return responseJson ? CareRecipientWithSensor.from(
        CareRecipientId.fromString(responseJson.id),
        CareRecipientName.fromString(responseJson.name),
        DateObject.fromString(responseJson.birthday),
        responseJson.houseId ? CareRecipientHouseId.fromString(responseJson.houseId) : null,
        responseJson.serviceProviderId? ServiceProviderId.fromString(responseJson.serviceProviderId) : null,
        responseJson.dataSyncStartTime ? DateTime.fromString(responseJson.dataSyncStartTime) : null,
        responseJson.dataSyncEndTime ? DateTime.fromString(responseJson.dataSyncEndTime) : null,
        responseJson.sensors.map(it => (getSensorFromValue(it.sensor))),
        responseJson.classification ? getCareRecipientClassificationFromValue(responseJson.classification) : null,
        responseJson.diseases,
        responseJson.alertPeriod?.start ? DateObject.fromString(responseJson.alertPeriod.start) : null,
        responseJson.alertPeriod?.end ? DateObject.fromString(responseJson.alertPeriod.end) : null,
        responseJson.alertPause,
        responseJson.branchCode ? BranchCode.fromString(responseJson.branchCode) : null,
        responseJson.customerCode ? CustomerCode.fromString(responseJson.customerCode) : null,
    ) : null;
};
